import I18n from "../../../../i18n";

const modalities = {
  group: I18n.t('setup.modalities.options.group'),
  personalized: I18n.t('setup.modalities.options.personalized'),
};

export default modalities;